module.exports = __webpack_public_path__ + "img/wave-5.9c58890e.svg";